<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="wrapperBox">
        <!-- content post -->
        <v-row class="createPostBtnWrapper">
          <v-col cols="12" class="py-0">
            <Post
              v-for="(item, key) in posts"
              :item="item"
              :key="key"
              @onData="onData"
            />
          </v-col>
        </v-row>
        <InfiniteLoad
          @loading="onLoadPost"
          :disabled="endData"
          :key="noDataSubscription"
        />
      </div>
    </v-col>
    <ModifyPost
      ref="dialogModifyPost"
      @postUpdated="handlePostUpdated"
      :courseId="courseId"
    />
  </v-row>
</template>
<script>
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
import ModifyPost from "@/components/Post/ModifyPost.vue";
import Post from "@/components/Post/Post.vue"; // post card
export default {
  name: "PostListTimeline",
  props: {
    courseId: { type: Number },
    postType: { type: Number },
  },
  components: {
    ModifyPost,
    Post,
    InfiniteLoad,
  },
  data() {
    return {
      posts: [],
      endData: false,
      currentPage: null,
      totalPages: null,
      pageContinue: 1,
      noDataSubscription: false, // he not follow any thing
      listPostIdHasShow: [],
    };
  },
  methods: {
    onData(item) {
      let i = this.posts.findIndex((x) => x.id == item.id);
      if (item.mode === "create") {
        delete item.mode;
        this.posts.splice(0, 0, item); //unshift
      } else if (item.mode === "update") {
        delete item.mode;
        const updated = { ...this.posts[i], ...item };
        this.$set(this.posts, i, updated);
      } else {
        this.posts.splice(i, 1);
        this.refreshComment();
      }
      return;
    },
    handlePostUpdated(updatedPost) {
      this.posts.forEach((post, index) => {
        if (post.id === updatedPost.id) {
          this.posts[index] = updatedPost;
        }
      });
      this.posts = JSON.parse(JSON.stringify(this.posts));
    },
    async onLoadPost(page) {
      const userId = localStorage.getItem("userId");
      if (userId && !this.noDataSubscription) {
        //load my subscription then get all
        if (this.currentPage && this.totalPages) {
          if (this.currentPage >= this.totalPages) {
            if (this.pageContinue === 1) {
              // add card befor get all
              const cardInfo = {
                type: "cardInfo",
                text: this.$gettext("You're All Caught Up"),
              };
              this.posts.push(cardInfo);
              if (this.listPostIdHasShow.length !== 0) {
                this.listPostIdHasShow = this.listPostIdHasShow.toString();
              } else this.listPostIdHasShow = "";
            }
            // get all
            const result = await this.getData(
              "post/getAllPost",
              this.pageContinue++,
              this.listPostIdHasShow
            );
            if (result.list.length == 0) {
              this.endData = true;
            }
          } else {
            // get subscription continue
            const result = await this.getData("post/getSubscriptions", page);
            this.setPageForGetSubscription(result);
          }
        } else {
          // get subscription
          const result = await this.getData("post/getSubscriptions", page);
          this.setPageForGetSubscription(result);
          if (result.totalPages == 0) {
            this.noDataSubscription = true;
          }
        }
      } else {
        //just get all
        const data = await this.getData("post/getAllPost", page);
        if (data.list.length == 0) {
          this.endData = true;
        }
      }
    },
    async getData(action, page, except_id) {
      let limit = 10;
      let result = await this.$store.dispatch(action, {
        page,
        limit,
        except_id,
      });
      if (!result.error) {
        if (result.list && result.list.length) {
          this.posts = this.posts.concat(result.list);
        }
      }
      return result;
    },
    setPageForGetSubscription(data) {
      this.currentPage = data.currentPage;
      this.totalPages = data.totalPages;
      if (data.list.length !== 0) {
        data.list.map((item) => {
          this.listPostIdHasShow.push(item.id);
        });
      }
    },
  },
};
</script>

